import styled from "styled-components";
import { borderRadius } from '@/assets/styles/constants';

export const FileManagementWrap = styled.div`
  display: flex;
  width: 100%;
  border-radius: ${borderRadius}px;
  overflow: hidden;
  border: 1px solid #e8eaed;
  background: #fff;

  .left {
    display: flex;
    flex-direction: column;
    min-width: 160px;
    border-right: 1px solid #e8eaed;
    background: #fafbfc;

    .left-tree {
      flex: 1;
      padding: 0 6px 0 2px;

      .ant-tree-treenode {
        margin: 0;
        padding: 1px 0;
        border-radius: ${borderRadius}px;
        transition: background-color 0.15s ease;

        &:hover {
          background-color: transparent;
        }
      }

      .ant-tree-indent-unit {
        width: 16px;
        position: relative;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          left: 8px;
          width: 1px;
          background: #e8ecf0;
        }
      }

      .ant-tree-node-content-wrapper {
        padding: 5px 8px;
        margin-left: 2px;
        border-radius: ${borderRadius}px;
        transition: all 0.15s ease;
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        color: #333;

        &:hover {
          background-color: rgba(0, 121, 191, 0.06);
        }
      }

      .ant-tree-node-content-wrapper.ant-tree-node-selected {
        background-color: rgba(0, 121, 191, 0.1);
        color: rgb(0, 121, 191) !important;
        font-weight: 600;
      }
    }
  }

  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .action-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 16px;
      border-bottom: 1px solid #e8eaed;
      background: #fafbfc;
      flex-shrink: 0;
      min-height: 40px;

      .search-bar {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }

    .content {
      display: flex;
      flex: 1;
      overflow: hidden;

      .file-list {
        flex: 3;
        overflow-y: auto;
        padding: 6px 0;
        background: #fff;

        .icon-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .file-list-item {
          padding: 7px 16px;
          display: flex;
          align-items: center;
          border-radius: ${borderRadius}px;
          cursor: pointer;
          margin: 1px 6px;
          transition: all 0.12s ease;

          &:hover {
            background-color: rgba(0, 121, 191, 0.05);
            color: inherit;
          }

          .icon-wrap {
            margin-right: 10px;
          }

          .name-text {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 13px;
          }

          /* 过滤结果里的实体目录：主标题（实体名）+ 副标题（EQ-xx / WO-xx） */
          .name-text-stacked {
            display: inline-flex;
            flex-direction: column;
            min-width: 0;
            max-width: 100%;
            line-height: 1.35;
            vertical-align: middle;
          }

          .name-text-primary,
          .name-text-secondary {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .name-text-secondary {
            font-size: 11px;
            font-weight: 400;
            color: #8c8c8c;
          }
        }
      }

      .preview-wrap {
        flex: 1;
        display: flex;
        border-left: 1px solid #f0f0f0;
        background-color: #fafafa;

        .preview {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 16px;
          overflow: auto;
        }
      }
    }
  }

  .ant-tree .ant-tree-treenode {
    margin: 0;
    padding: 2px 0;
  }

  .ant-tree.ant-tree-directory .ant-tree-treenode-selected::before,
  .ant-tree.ant-tree-directory .ant-tree-treenode-selected:hover::before {
    background: transparent !important;
  }

  .ant-tree-switcher {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
  }

  .ant-tree-indent-unit {
    width: 14px;
  }

  .ant-table-row {
    transition: background-color 0.15s ease;

    .NameDropdownMenu {
      opacity: 0;
      transition: opacity 0.15s ease;
    }

    &:hover {
      .NameDropdownMenu {
        opacity: 1;
      }
    }
  }

  .ant-tree-node-content-wrapper.ant-tree-node-selected {
    color: unset !important;
  }

  .ant-tag {
    border-radius: 4px;
    font-size: 12px;
    line-height: 18px;
  }

  .ant-breadcrumb {
    font-size: 13px;

    .ant-breadcrumb-link {
      transition: color 0.15s ease;
      padding: 2px 4px;
      border-radius: 4px;

      &:hover {
        background: rgba(0, 121, 191, 0.06);
        color: rgb(0, 121, 191);
      }
    }

    .ant-breadcrumb-separator {
      color: #c0c4cc;
      margin: 0 4px;
      font-size: 11px;
    }

    .ant-breadcrumb-item:last-child .ant-breadcrumb-link {
      color: #333;
      font-weight: 500;
      cursor: default;

      &:hover {
        background: transparent;
        color: #333;
      }
    }
  }
`;

export const ActionBarWrap = styled.div`
  height: 48px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fafbfc;
  border-bottom: 1px solid #e8eaed;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  gap: 12px;
  flex-shrink: 0;
  position: relative;
  z-index: 2;

  .action-left {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .action-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ant-btn {
    border-radius: ${borderRadius}px;
    font-size: 13px;
    transition: all 0.15s ease;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 32px;
    padding: 0 10px;
    color: #444;

    &:hover {
      border-color: rgb(0, 121, 191);
      color: rgb(0, 121, 191);
      background: rgba(0, 121, 191, 0.04);
    }

    &:active {
      background: rgba(0, 121, 191, 0.08);
    }
  }

  .ant-btn-primary {
    background: rgb(0, 121, 191);
    border-color: rgb(0, 121, 191);
    color: #fff;

    &:hover {
      background: rgb(0, 107, 170);
      border-color: rgb(0, 107, 170);
      color: #fff;
    }
  }

  .search-input {
    width: 220px;
    border-radius: ${borderRadius}px !important;

    .ant-input {
      font-size: 13px;
    }

    .ant-input-prefix {
      color: #bbb;
      margin-right: 6px;
    }

    &:hover {
      border-color: rgb(0, 121, 191);
    }

    &:focus,
    &:focus-within,
    &.ant-input-affix-wrapper-focused {
      box-shadow: 0 0 0 2px rgba(0, 121, 191, 0.1) !important;
      border-color: rgb(0, 121, 191) !important;
    }
  }

  .filter-select {
    min-width: 130px;

    .ant-select-selector {
      font-size: 13px !important;
      border-radius: ${borderRadius}px !important;

      &:hover {
        border-color: rgb(0, 121, 191) !important;
      }
    }

    &.ant-select-focused .ant-select-selector {
      box-shadow: 0 0 0 2px rgba(0, 121, 191, 0.1) !important;
      border-color: rgb(0, 121, 191) !important;
    }
  }

  .ant-input-affix-wrapper {
    border-radius: ${borderRadius}px;
  }
`;
